"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.flat.js");
require("core-js/modules/es.array.unscopables.flat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.concat.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Popover 的文档地址：https://tportal.woa.com/doc/tea-portal/components/data-display/popover

var Search = function Search(props) {
  var data = props.data,
    _props$emptyList = props.emptyList,
    emptyList = _props$emptyList === void 0 ? [] : _props$emptyList,
    _props$onChoose = props.onChoose,
    onChoose = _props$onChoose === void 0 ? function (arg) {} : _props$onChoose,
    _props$isActive = props.isActive,
    isActive = _props$isActive === void 0 ? false : _props$isActive;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('nav');
  var searchRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(385),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    dropdownWidth = _useState2[0],
    setDropdownWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    searchVal = _useState4[0],
    setSearchVal = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    visible = _useState6[0],
    setVisible = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    result = _useState8[0],
    setResult = _useState8[1];
  // useState<Array<{title?:string;text?:string}>>=([]);
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    showResult = _useState10[0],
    setShowResult = _useState10[1];
  (0, _react.useEffect)(function () {
    if (searchRef.current) {
      setDropdownWidth(searchRef.current.getBoundingClientRect().width);
    }
  });
  (0, _react.useEffect)(function () {
    if (!isActive) {
      setVisible(false);
      setShowResult(false);
      setSearchVal('');
      setResult([]);
    }
  }, [isActive]);
  var onSearch = function onSearch() {
    var list = data === null || data === void 0 ? void 0 : data.flat().map(function (i) {
      return i.children;
    }).flat();
    var _result = list === null || list === void 0 ? void 0 : list.filter(function (i) {
      return i.title.includes(searchVal) || i.text.includes(searchVal);
    });
    console.log('searchVal', _result, searchVal, 'emptyList=>', emptyList);
    setResult(_result || []);
    setShowResult(true);
    setVisible(true);
  };
  var resultPart = /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search-result")
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__search-result-icon")
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search-result-text")
  }, "\u6CA1\u6709\u627E\u5230\u7ED3\u679C\u5BF9\u5E94\u8BC6\u522B\u65B9\u5F0F"), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search-result-recom")
  }, /*#__PURE__*/_react.default.createElement("span", null, "\u63A8\u8350\u4F7F\u7528\uFF1A"), emptyList.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("a", {
      onClick: function onClick(e) {
        console.log('item', item);
        e.preventDefault();
        onChoose(item);
      },
      key: index,
      href: "#",
      className: "".concat(prefixCls, "__search-tag")
    }, item.title);
  })));
  var menuPart = /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(prefixCls, "__search-menu")
  }, (result === null || result === void 0 ? void 0 : result.length) > 0 && result.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "".concat(prefixCls, "__search-item"),
      key: index
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        onChoose(item);
      }
    }, /*#__PURE__*/_react.default.createElement("h4", {
      className: "".concat(prefixCls, "__search-item-title")
    }, item.title), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__search-item-desc")
    }, item.text)));
  }));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search-box")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search-tip")
  }, "\u627E\u4E0D\u5230\u6240\u9700\u7684\u8BC6\u522B\u6A21\u578B\uFF1F\u8BD5\u8BD5\u641C\u7D22"), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search"),
    ref: searchRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search-bar")
  }, /*#__PURE__*/_react.default.createElement("input", {
    value: searchVal,
    type: "text",
    className: "".concat(prefixCls, "__search-input"),
    placeholder: '请描述所识别场景或材料名称  参考形式：身份证识别'
    //    onFocus={() => setVisible(true)}
    ,
    onChange: function onChange(e) {
      return setSearchVal(e.target.value);
    },
    onBlur: function onBlur(e) {
      setSearchVal(e.target.value);
      setVisible(false);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        onSearch();
      }
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    onClick: onSearch,
    className: "".concat(prefixCls, "__search-btn")
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__search-icon")
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search-dropdown ").concat(showResult ? 'active' : '')
  }, result.length > 0 ? menuPart : resultPart)));
};
var _default = exports.default = Search;